import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { LoadingComponent } from '../core/dialogs/loading/loading.component';
import { LockHinweisComponent } from '../core/dialogs/lock-hinweis/lock-hinweis.component';
import { AlertComponent } from '../core/dialogs/alert/alert.component';
import { DecimalPipe } from '@angular/common';
import { Injectable } from '@angular/core';
import { JeinDialogComponent } from '../shared/jein-dialog/jein-dialog.component';
import { BehaviorSubject } from 'rxjs';
import { Call } from 'sharedTypes/call';
import { FEIERTAGEARRAY } from '../static/feiertage';

const FEIERTAGE = JSON.parse(FEIERTAGEARRAY);

@Injectable()
export class GlobalService {
    constructor(
        public snackBar: MatSnackBar,
        private dialog: MatDialog,
        private router: Router,
        private decimalPipe: DecimalPipe,
    ) {
        this.startZeit();
    }

    steuerer = [
        'HUK',
        'SPN',
        'riparo',
        'Innovation Group',
        'Innovation Group Fleet',
        'Mobexo',
        'Postfleet',
        'Leaseplan',
        'Arval',
        'Alphabet',
        'Belmoto',
        'Carsync',
        'Consense',
        'DEVK',
        'DMS',
        'Eurogarant',
        'Provinzial',
        'Mobility First',
        'Sixt',
    ];

    zeit = new BehaviorSubject<number>(new Date().getTime());
    zeitLaeuft = false;
    users = [
        {
            name: 'J.Bücher',
            shortName: 'JB',
            sipgateUserId: 'w0',
            uid: '0l7u6A6afVTgngfcK0k9Dllprxt2',
            hatTermine: true,
            isSupport: true,
            isTicketSupport: true,
            stundenFaktor: 40 / 40,
            inaktiv: false,
        },
        {
            name: 'M.Schwemler',
            shortName: 'MS',
            sipgateUserId: 'w19', // w1
            uid: 'HoFQatfpsHcwDQdnuQPnhBOsNIl1',
            hatTermine: false,
            isTicketSupport: true,
            isSupport: true,
            stundenFaktor: 40 / 32,
            inaktiv: false,
        },
        {
            name: 'Marc-Andre Schwemler',
            shortName: 'AS',
            sipgateUserId: 'w5',
            uid: 'mQlBWJHssrTxL6wUWtBpWTuajA92',
            hatTermine: true,
            isSupport: true,
            stundenFaktor: 40 / 40,
            inaktiv: false,
        },
        {
            name: 'Alaa Mlaouhi',
            shortName: 'AM',
            sipgateUserId: '',
            uid: 'l4trCHr0IdVqeyeUrbKDeiiIxzF2',
            hatTermine: false,
            inaktiv: false,
        },
        {
            name: 'David Hillmer',
            shortName: 'DH',
            sipgateUserId: '',
            uid: 'eO6j77rbSyMrb8HbaPixCHUBuk03',
            hatTermine: false,
            inaktiv: true,
        },
        {
            name: 'Daria Mousavi',
            shortName: 'DM',
            sipgateUserId: '',
            uid: 'lMPtCqto57ahSsz4sm5FzZrKD3w1',
            hatTermine: false,
            inaktiv: false,
        },
        {
            name: 'Nico Söhnlein',
            shortName: 'NS',
            sipgateUserId: 'w6',
            uid: 'rCAHYUkwnkStlcnFMJFt89WpWbi2',
            hatTermine: true,
            isSupport: true,
            isTicketSupport: true,
            stundenFaktor: 40 / 40,
            inaktiv: false,
        },
        {
            name: 'Hamza Mnari',
            shortName: 'NS',
            sipgateUserId: '',
            uid: 'Hamza',
            hatTermine: false,
            inaktiv: true,
        },
        {
            name: 'Erwin Neves',
            shortName: 'EN',
            sipgateUserId: 'w7',
            uid: 'EVSERbTNVVRe82OhKYDDogMJEDf2',
            hatTermine: false,
            isSupport: true,
            stundenFaktor: 40 / 20,
            inaktiv: true,
        },
        {
            name: 'Alexander Meller',
            shortName: 'AL',
            sipgateUserId: 'w8',
            uid: 'C5seVkUuPcX1vgPGQuanhonJOWH2',
            hatTermine: true,
            isSupport: true,
            stundenFaktor: 40 / 40,
            inaktiv: false,
        },
        {
            name: 'Markus Gstalter',
            shortName: 'MG',
            sipgateUserId: 'w9',
            uid: 'mRgnSlG643ZBjTCf8ADeLQAOhVA2',
            hatTermine: false,
            isSupport: true,
            stundenFaktor: 40 / 40,
            inaktiv: false,
        },
        {
            name: 'Oliver Uus',
            shortName: 'OU',
            sipgateUserId: '',
            uid: 'u8BsCy3VSXZ0jWTYpSYZ4lmb62h2',
            hatTermine: false,
            isSupport: true,
            stundenFaktor: 40 / 40,
            inaktiv: false,
        },
        {
            name: 'Linda Boldt',
            shortName: 'LB',
            sipgateUserId: 'w10',
            uid: 'fts6Y6NDEwdQlnfwy6TabY9KX0w1',
            hatTermine: false,
            isSupport: false,
            isTicketSupport: true,
            stundenFaktor: 40 / 40,
            inaktiv: true,
        },
        {
            name: 'John Dedato',
            shortName: 'JD',
            sipgateUserId: 'w11',
            uid: 'yd5EIvY2n5NhVOT6EIJLrvbxkZ22',
            hatTermine: false,
            isSupport: true,
            isTicketSupport: true,
            stundenFaktor: 40 / 32,
            inaktiv: false,
        },
        {
            name: 'Arthur Nebe',
            shortName: 'AN',
            sipgateUserId: 'w12',
            uid: '8fvmgFqaYYPbAe9pMnQHt3lGm7r2',
            hatTermine: false,
            isSupport: false,
            stundenFaktor: 40 / 40,
            inaktiv: true,
        },
        {
            name: 'Lara Spiegler',
            shortName: 'LS',
            sipgateUserId: 'w13',
            uid: 'K1eAnTcKulgW9ePRiTcaLS4U4aD3',
            hatTermine: true,
            isSupport: true,
            stundenFaktor: 40 / 40,
            inaktiv: false,
        },
        {
            name: 'Nilgün Altunbas',
            shortName: 'NA',
            sipgateUserId: 'w15',
            uid: 'chTbYt0gsRRAQHnds5e1gmk97ks2',
            hatTermine: false,
            isSupport: true,
            stundenFaktor: 40 / 40,
            inaktiv: true,
        },
        {
            name: 'Ann-Kathrin Hagenbruch',
            shortName: 'AH',
            sipgateUserId: 'w17',
            uid: 'tsjG4JomlDXMS5cPExeDnNr01462',
            hatTermine: true,
            isSupport: true,
            stundenFaktor: 40 / 40,
            inaktiv: true,
        },
        {
            name: 'Marcel Kessler',
            shortName: 'MK',
            sipgateUserId: 'w18',
            uid: 'el6p7lwMyBMYp0BtxPLcItiwqeq2',
            hatTermine: true,
            isSupport: true,
            stundenFaktor: 40 / 40,
            inaktiv: true,
        },
        {
            name: 'Lisa Buss',
            shortName: 'LBU',
            sipgateUserId: 'w20',
            uid: 'UQoERMrNffUontob7SlPtJfOcIu2',
            hatTermine: false,
            isSupport: true,
            isTicketSupport: true,
            stundenFaktor: 40 / 40,
            inaktiv: false,
        },
        {
            name: 'Holger Stöckel',
            shortName: 'HS',
            sipgateUserId: 'wxxxx',
            uid: 'wkCFH3LZkFOEp6Yuuw9G54UWHGu2',
            hatTermine: true,
            isSupport: true,
            stundenFaktor: 40 / 40,
            inaktiv: false,
        },
        {
            name: 'Franzi Schick',
            shortName: 'FS',
            sipgateUserId: 'w21',
            uid: 'BRWD65yqhEXvnsUJMbd57ltW8AZ2',
            hatTermine: true,
            isSupport: true,
            stundenFaktor: 40 / 40,
            inaktiv: false,
        },
        {
            name: 'Marius Schantz',
            shortName: 'MAR',
            sipgateUserId: 'w23',
            uid: '50W2BusTTUcxTlBLUs4UrXKz5bZ2',
            hatTermine: true,
            isSupport: true,
            stundenFaktor: 40 / 40,
            inaktiv: false,
        },
        {
            name: 'Felix Dehnert',
            shortName: 'FD',
            sipgateUserId: 'w24',
            uid: 'sPws8EIwQQflbVgYjcGQ4hYmWXI2',
            hatTermine: true,
            isSupport: true,
            stundenFaktor: 40 / 40,
            inaktiv: false,
        },
    ];
    activeUsers = this.users.filter((u) => !u.inaktiv);
    activeSupportUsers = this.users.filter((u) => !u.inaktiv && u.isSupport);
    activeTicketSupportUsers = this.users.filter((u) => !u.inaktiv && u.isTicketSupport);
    loadingDialogRef: any;
    lockHinweisOpen = false;
    weekday = ['Sonntag', 'Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Samstag'];
    weekdayShort = ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'];

    startZeit() {
        if (!this.zeitLaeuft) {
            // this.trackOfTime();
            this.zeitLaeuft = true;
        }
    }

    trackOfTime() {
        setTimeout(() => {
            this.zeit.next(Date.now());
            this.trackOfTime();
        }, 600);
    }

    sortedUsers() {
        return this.users.sort((a: any, b: any) => {
            if (a.name > b.name) {
                return 1;
            }
            if (a.name < b.name) {
                return -1;
            }
            return 0;
        });
    }
    getDETagWeekday(weekday: any) {
        return this.weekday[weekday];
    }

    getDauer(call: Call) {
        return this.getZeitWort(((call.endedAtUnix || Date.now()) - call.startAtUnix) / 1000 / 60);
    }

    getZeitWort(min: number, allowminus = false) {
        let istminus = false;
        if (min < 0) {
            istminus = true;
            min = Math.abs(min);
        }

        let minuten = (min % 60).toFixed(0).toString().split('.').join(',');
        let secs = Math.floor(60 * ((min % 60) - Math.floor(min)));
        let stunden = min / 60 - (min % 60) / 60;

        const tage = stunden / 24 - (stunden % 24) / 24;
        const tagestr = tage.toFixed(0);
        let rueck = '';
        if (istminus) {
            rueck = '-';
        }
        if (tage > 0) {
            rueck = rueck + tagestr + ' T. ';
            stunden = stunden - tage * 24;
        }
        const stundenstr = stunden.toFixed(0);
        if (min % 60 < 10) {
            minuten = '0' + minuten;
        }
        let stundenminstr = '';

        if (stunden > 0) {
            stundenminstr = stundenminstr + stundenstr + ':';
        }
        rueck = rueck + stundenminstr + minuten + ':' + secs;
        return rueck;
    }

    sendSnack(message: string) {
        const cfg = new MatSnackBarConfig();
        cfg.duration = 3000;
        this.snackBar.open(message, '', cfg);
    }

    startLoading(message = 'Bitte warten') {
        const cfg = new MatDialogConfig();
        // cfg.id = 'loading';
        cfg.width = '300px';
        cfg.disableClose = true;
        cfg.data = { message: message };
        this.loadingDialogRef = this.dialog.open(LoadingComponent, cfg);
    }

    alert(message: string, title = null) {
        const cfg = new MatDialogConfig();
        cfg.width = '300px';
        cfg.disableClose = true;
        cfg.data = { message: message, title: title };
        this.loadingDialogRef = this.dialog.open(AlertComponent, cfg);
    }

    endLoading() {
        if (this.loadingDialogRef) {
            this.loadingDialogRef.close();
        }
    }

    getLines(text: any) {
        if (!text) {
            return '';
        }
        return text.split('\n').join('<br>');
    }

    openLockHinweis(header: string, message: string, showReload: boolean) {
        if (!this.lockHinweisOpen) {
            this.router.navigate(['/home']);
            this.lockHinweisOpen = true;
            const cfg = new MatDialogConfig();
            cfg.width = '300px';
            cfg.disableClose = true;
            cfg.data = { header: header, message: message, showReload: showReload };
            this.dialog.open(LockHinweisComponent, cfg);
        }
    }

    confirm(message: string, jatext = 'Ja', neintext = 'Nein', title = null) {
        const cfg = new MatDialogConfig();
        cfg.width = '300px';
        cfg.disableClose = true;
        cfg.data = { frage: message, title: title, ja: jatext, nein: neintext };
        return this.dialog.open(JeinDialogComponent, cfg).afterClosed();
    }

    sI(input: any) {
        // Input für Rechnungen aufbereiten
        if (!input) {
            return 0;
        }
        if (isNaN(parseInt(input.split(',').join('.'), 10))) {
            return 0;
        }
        return parseInt(input.split(',').join('.'), 10);
    }

    getClientTypeName(clientType: string) {
        let clientTypeName = 'Kunde';
        if (clientType === 'delle') {
            clientTypeName = 'Dellentechnik';
        }
        if (clientType === 'kul') {
            clientTypeName = 'Karosserie & Lack';
        }
        if (clientType === 'kulm') {
            clientTypeName = 'Karosserie & Lack + Mechanik';
        }
        if (clientType === 'mechanik') {
            clientTypeName = 'Mechanik';
        }
        if (clientType === 'aufbereiter') {
            clientTypeName = 'Aufbereiter';
        }
        return clientTypeName;
    }

    getLeadTypeName(leadType: string) {
        let leadTypeName = 'Kontakt';
        if (leadType === 'basis') {
            leadTypeName = 'Basis Interessent';
        }
        if (leadType === 'kul') {
            leadTypeName = 'Karosserie & Lack';
        }
        if (leadType === 'misc') {
            leadTypeName = 'Sonstiger Kontakt';
        }
        return leadTypeName;
    }

    getCountryName(country: string) {
        let land = '';
        if (country === 'DE') {
            land = 'Deutschland';
        }
        if (country === 'AT') {
            land = 'Österreich';
        }
        if (country === 'CH') {
            land = 'Schweiz';
        }

        return land;
    }

    getUserNameMitId(uid: string) {
        let name = uid;
        this.users.forEach((u) => {
            if (u.uid === uid) {
                name = u.name;
            }
        });
        return name;
    }
    getUserMitId(uid: string) {
        let user = {};
        this.users.forEach((u) => {
            if (u.uid === uid) {
                user = u;
            }
        });
        return user;
    }
    getUserShortMitId(uid: string) {
        let name = uid;
        this.users.forEach((u) => {
            if (u.uid === uid) {
                name = u.shortName;
            }
        });
        return name;
    }

    checkFeiertag(tag: number, monat: number, jahr: number) {
        const suche = FEIERTAGE.filter((feiertag: any) => {
            if (feiertag.jahr === jahr && feiertag.monat === monat && feiertag.tag === tag && feiertag.bl === 'BE') {
                return feiertag;
            }
        });
        if (suche.length > 0) {
            if (suche[0].feiertag === 'Fronleichnam') {
                return false;
            }
            if (suche[0].feiertag === 'Mariä Himmelfahrt') {
                return false;
            }
            if (suche[0].feiertag === 'Augsburger Friedensfest') {
                return false;
            }
        }
        if (suche.length > 0) {
            return suche[0];
        }
        return false;
    }

    checkIstFeiertagUnix(unixtime: number) {
        const tag = new Date(unixtime).getDate();
        const monat = new Date(unixtime).getMonth();
        const jahr = new Date(unixtime).getFullYear();
        return this.checkFeiertag(tag, monat + 1, jahr);
    }
    checkIstFeiertagIso(dateString: string) {
        return this.checkIstFeiertagUnix(new Date(dateString).getTime());
    }
}
